module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIyNSIgdmlld0JveD0iMCAwIDMwMSAyMjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA3RkZGIiBkPSJNLjUgMGgzMDB2MjI1SC41eiIvPjxwYXRoIGQ9Ik0xNCA0NWgzMS41bDkuNzUtMzEuNUw2NSA0NWgzMS41TDcxIDY0LjUgODAuNzUgOTZsLTI1LjUtMTkuNUwyOS43NSA5Nmw5Ljc1LTMxLjVMMTQgNDV6TTI4MS43NSAwTC41IDE2OC43NVYyMjVoMTguNzVMMzAwLjUgNTYuMjVWMGgtMTguNzV6IiBmaWxsPSIjRjdENjE4Ii8+PHBhdGggZmlsbD0iI0NFMTAyMSIgZD0iTTMwMC41IDBMLjUgMTgwdjQ1bDMwMC0xODBWMCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-cd.svg
// module id = merT
// module chunks = 2